import styles from './CommonNotification.module.scss';

import { Toast } from '@/components/Toast';
import { useStore } from '@/store';

import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

export const CommonNotification = observer(() => {
  const {
    notificationStore: { setNotificationType, notificationMessage },
  } = useStore();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setNotificationType(null);
    }, 3000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Toast>
      <div className={styles.wrapper}>{notificationMessage}</div>
    </Toast>
  );
});
